import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Eyebrow } from './ui.jsx';
import useReveal from '../hooks/useReveal.js';
import { displayFont, tokens } from '../theme.js';

export default function InstitutionalFinance() {
  const { t } = useTranslation();
  const benefits = t('institutions.benefits', { returnObjects: true });
  const ref = useReveal();

  return (
    <Box component="section" id="institutions" sx={{ bgcolor: tokens.dark, color: '#fff', py: { xs: 8, md: 12 } }}>
      <Container ref={ref} className="reveal" maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.05fr 0.95fr' }, gap: { xs: 5, md: 8 }, alignItems: 'center' }}>
          <Box>
            <Eyebrow onDark>{t('institutions.eyebrow')}</Eyebrow>
            <Typography variant="h2" sx={{ maxWidth: '22ch' }}>{t('institutions.title')}</Typography>
            <Typography sx={{ color: tokens.mutedOnDark, maxWidth: '57ch', mt: 2.5 }}>{t('institutions.body')}</Typography>
            <Button variant="contained" href="#contact" size="large" sx={{ mt: 4 }}>{t('institutions.cta')}</Button>
          </Box>
          <Box sx={{ display: 'grid', gap: 1.5 }}>
            {benefits.map((benefit) => (
              <Box key={benefit.title} sx={{ p: 3, bgcolor: 'rgba(255,255,255,0.045)', border: `1px solid ${tokens.lineOnDark}` }}>
                <Typography sx={{ fontFamily: displayFont, fontWeight: 600, color: '#fff' }}>{benefit.title}</Typography>
                <Typography sx={{ color: tokens.mutedOnDark, fontSize: '0.9rem', mt: 0.75 }}>{benefit.body}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
